import { defineStore } from 'pinia'
import type { BaseApiSEO, ConfigApiData, ConfigInfoApi } from '~/server/types'
export interface CONFIG extends ConfigApiData {
  id?: number // 作为lang_id参数
}
export const useStore = defineStore('Config', () => {
  const config = ref<CONFIG>({} as CONFIG)
  const toast = ref({
    show: false,
    message: 'Text Text Text',
    type: 'error',
    duration: 3000,
    closeOnClick: false
  })
  function showToast(
    message: string,
    type: 'error' | 'success' | 'message' = 'message',
    duration: number = 3000,
    closeOnClick = false
  ) {
    toast.value.show = true
    toast.value.message = message
    toast.value.type = type
    toast.value.duration = duration
    toast.value.closeOnClick = closeOnClick
  }
  async function fetchConfig() {
    const route = useRoute()
    const lang = route.params.lang || ''
    const res = await useFetch(`/api/config?lang=${lang}`)
    const data = (res.data.value as ConfigInfoApi).data
    setConfig(data)
  }
  function setConfig(data: ConfigApiData) {
    config.value = data
    config.value.id = config.value.lang_list.find((item) => {
      return item.region === 'GLOBAL'
        ? item.lang === config.value.region_lang
        : `${item.region}_${item.lang}` === config.value.region_lang
    })?.id
  }
  function updateSEO(seo?: BaseApiSEO) {
    if (!seo) {
      seo = config.value.footer.seo
    }
    if (seo) {
      useHead({
        htmlAttrs: {
          'data-lang': config.value.region_lang
        },
        title: seo.title,
        meta: [
          {
            name: 'description',
            content: seo.description
          },
          {
            name: 'keywords',
            content: seo.keywords
          }
        ]
      })
    }
  }
  function formatTransify(key: string) {
    return config.value.transify?.[key] || key
  }
  async function submitFormData(params: any) {
    try {
      return await $fetch('/proxy/api/preregister', {
        method: 'POST',
        body: { ...params }
      })
    } catch (error) {
      showToast('Request failed. Please try again later.', 'error')
      throw new Error('Request failed. Please try again later. ')
    }
  }
  return {
    config,
    toast,
    submitFormData,
    fetchConfig,
    showToast,
    updateSEO,
    formatTransify
  }
})
